import { commonTypes } from '../common';

export const initialState = {
  hasPromotionApplied: false,
  disagregateProducts: null,
  priceChange: null,
  afterSaleProduct: null,
  insuranceData: null,
};

export const types = {
  SET_DISAGREGATE_PRODUCT: 'APISNEEDS/SET_DISAGREGATE_PRODUCT',
  SET_AFTER_SALE_PRODUCT: 'APISNEEDS/SET_AFTER_SALE_PRODUCT',
  SET_INSURANCE_DATA: 'APISNEEDS/SET_INSURANCE_DATA',
};

const ApisNeedsPrices = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_ALL_PROMOS_ID: {
      const { allPromos } = action.payload;

      if (Array.isArray(allPromos) && allPromos.length > 0) {
        return {
          ...state,
          hasPromotionApplied: true,
        };
      }

      return {
        ...state,
      };
    }
    case types.SET_DISAGREGATE_PRODUCT: {
      const disagregateProducts = action.payload;
      return {
        ...state,
        disagregateProducts,
      };
    }
    case commonTypes.SET_PRICES_CHANGE_INFO: {
      const priceChange = action.payload;
      return {
        ...state,
        priceChange,
      };
    }
    case types.SET_AFTER_SALE_PRODUCT: {
      const product = action.payload;
      return {
        ...state,
        afterSaleProduct: product,
      };
    }
    case types.SET_INSURANCE_DATA: {
      const { insuranceData } = action.payload;

      return {
        ...state,
        insuranceData,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setDisagregateProduct: info => ({
    type: types.SET_DISAGREGATE_PRODUCT,
    payload: {
      ...info,
    },
  }),
  setAfterSaleProduct: product => ({
    type: types.SET_AFTER_SALE_PRODUCT,
    payload: {
      ...product,
    },
  }),
  setInsuranceData: insuranceData => ({
    type: types.SET_INSURANCE_DATA,
    payload: {
      insuranceData,
    },
  }),
};

export default ApisNeedsPrices;
